import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=6e3cd7ff&"
import script from "./BookingDetail.vue?vue&type=script&lang=ts&"
export * from "./BookingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports